import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, createClass as _createClass, wrapNativeSuper as _wrapNativeSuper } from "../_virtual/_rollupPluginBabelHelpers.js";
import { LoaderType } from "./types.js";
var NetError = /* @__PURE__ */ function(_Error) {
  _inherits(NetError2, _Error);
  var _super = _createSuper(NetError2);
  function NetError2(url, request, response, msg) {
    var _this;
    _classCallCheck(this, NetError2);
    _this = _super.call(this, msg);
    _defineProperty(_assertThisInitialized(_this), "retryCount", 0);
    _defineProperty(_assertThisInitialized(_this), "isTimeout", false);
    _defineProperty(_assertThisInitialized(_this), "loaderType", LoaderType.FETCH);
    _defineProperty(_assertThisInitialized(_this), "startTime", 0);
    _defineProperty(_assertThisInitialized(_this), "endTime", 0);
    _defineProperty(_assertThisInitialized(_this), "options", {});
    _this.url = url;
    _this.request = request;
    _this.response = response;
    return _this;
  }
  return _createClass(NetError2);
}(/* @__PURE__ */ _wrapNativeSuper(Error));
export { NetError };
